import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import{MemoryStorageService} from 'src/app/services/memory-storage.service';
@Component({
  selector: 'app-help-section-details',
  templateUrl: './help-section-details.component.html',
  styleUrls: ['./help-section-details.component.css']
})
export class HelpSectionDetailsComponent implements OnInit {
  toggle: boolean = false;

  lstHelpData = [];
  category = "";
  categoryIndex = 0;

  videoName = "";
  videoPath = "";
  @ViewChild('videoPlayer') videoplayer: ElementRef;

  constructor(private dataService: DataService, private route: Router, private commonService: CommonService, private httpClient: HttpClient,private memorystore:MemoryStorageService) { }

  ngOnInit(): void {
    // this.category = this.commonService.getUserInfoFromLocalStorage('Category');
    this.category = this.memorystore.getItem('Category');
    this.getHelpDetail();
  }

  clickEvent(event) {
    this.toggle = !this.toggle;
  }

  getHelpDetail() {
    this.lstHelpData = [];
    let params = new HttpParams();
    params = params.append("category", this.category);
    // params = params.append("projectId", this.commonService.getUserInfoFromLocalStorage('projectId'));
    // params = params.append("roleId", this.commonService.getUserInfoFromLocalStorage('roleId'));
    params = params.append("projectId", this.memorystore.getItem('projectId'));
    params = params.append("roleId", this.memorystore.getItem('roleId'));
    this.dataService.getData('dashboard/help', params).subscribe((res) => {
      if (res != null && (res.errorMessage == null || res.errorMessage == "")) {
        if (res.success == true) {
          this.lstHelpData = res.data;
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        this.commonService.showMessageBox(error.toString());
        if (error.includes("401")) {
          this.route.navigateByUrl('/unauthorized');
          return;
        }
      });
  }
  download(url: string, title: string) {
    var base64data;
    if (url !== '') {
      if (this.fileExists(url)) {
        this.httpClient.get(url, { responseType: 'blob' })
          .subscribe(res => {
            const reader = new FileReader();
            reader.onloadend = () => {
              base64data = reader.result.toString().replace('data:application/pdf;base64,', '');
              if (base64data) {
                const downloadLink = document.createElement('a');
                downloadLink.href = reader.result as string;
                downloadLink.download = title;
                downloadLink.click();
                reader.abort();
              }
            }
            reader.readAsDataURL(res);
          });
      }
    }
  }
  downloadFile(url: string) {
    if (url !== '') {
      var base64data;
      if (url !== '') {
        if (this.fileExists(url)) {
          var fileExtension = url.split('?')[0].split('.').pop();
          if (fileExtension.toLowerCase().replace(/\n|\r/g, "") === 'pdf') {
            let invoiceFileWindow = window.open('');
            this.httpClient.get(url, { responseType: 'blob' })
              .subscribe(res => {
                const reader = new FileReader();
                reader.onloadend = () => {
                  base64data = reader.result.toString().replace('data:application/pdf;base64,', '');
                  if (base64data) {
                    invoiceFileWindow.document.write(
                      `<style>body{margin:0;} iframe{border:none;}</style><iframe width='100%' height='100%' src='data:application/pdf;base64, ${encodeURI(
                        base64data
                      )}'></iframe>`
                    );
                    reader.abort();
                  }
                }
                reader.readAsDataURL(res);
              });
          }
          else {
            this.commonService.showMessageBox('Pdf Document can be viewed');
          }
        }
      }
      else {
        this.commonService.showMessageBox('Document not found');
      }
    }
  }
  fileExists(url: string) {
    var xhr = new XMLHttpRequest();
    xhr.open('HEAD', url, false);
    xhr.send();

    if (xhr.status === 404) {
      return false;
    } else {
      return true;
    }
  }
  videoClick(vname, vpath) {
    this.videoName = vname;
    this.videoPath = vpath;
    this.videoplayer.nativeElement.src = this.videoPath;
    this.videoplayer.nativeElement.play();
  }
  closeVideo() {
    this.videoplayer.nativeElement.pause();
  }
}
